const numberOfSecondsInAYear = 60 * 60 * 24 * 365.25;

export const AgeComputed = (_bday: number, _bmonth: number, byear: number) => new Date().getFullYear() - byear;
// This function calculates 'half age' of the lead. Based on testing, this may compute the half age a bit differently
// if the user falls exactly on the 6 month mark, LSW considers them to be age older. So this function accounts for that.
export const AgeComputedRounded = (bday: number, bmonth: number, byear: number) => {
    const today = new Date();
    const todayInSecondsSinceEpoch = Math.round(today.getTime() / 1000);
    const bdayInSecondsSinceEpoch = Math.round(new Date(byear, bmonth - 1, bday).getTime() / 1000);
    return Math.round((todayInSecondsSinceEpoch - bdayInSecondsSinceEpoch) / numberOfSecondsInAYear);
};

export const AgeComputedCalendar = (bday: number, bmonth: number, byear: number) => {
    var today = new Date();
    var age = today.getFullYear() - byear;
    var m = today.getMonth() - bmonth + 1;
    if (m < 0 || (m === 0 && today.getDate() < bday)) {
        age--;
    }
    return age;
};
